import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {ClipboardService} from 'ngx-clipboard';
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit} from "@angular/core";

@Component({
	selector: 'archive-configurations-general-component',
	templateUrl: './archive-configurations-general.component.html',
})
export class ArchiveConfigurationsGeneralComponent implements OnInit {
    constructor(private rs:RouteService,
				private ns:NotificationService,
				private clipboard: ClipboardService,
				public gs:GeneralService){
    }

    dic = DICTIONARY;

	isLoaded = false;
    config;
    usage;
    reviewers;
	editRetentionPeriod: any;
    userInfo;
	planInfo;

	journalEmailAddress;
	showJournalAddress: boolean;

	ngOnInit() {
        this.gs.getUserInfo(false, (userInfo) => {
            this.userInfo = userInfo;
        });

		this.rs.getArchiveConfiguration().then(response => {
            this.config = response.archive;
            this.usage = response.usage || {};
			this.journalEmailAddress = response.journalEmailAddress;
			this.planInfo = response.planInfo;

            this.reviewers = response.archive.reviewers;
			this.isLoaded = true;
        }, (err) => {
			this.isLoaded = true;
		});
    };

	copyJournalEmailToClipboard() {
		this.clipboard.copy(this.journalEmailAddress);
		this.ns.showInfoMessage(util.format(DICTIONARY.MESSAGES.copyClipboard, "Journal email address"));
	};

    updateArchiveConfigurations = (actionType) => {
        switch (actionType) {
            case this.dic.CONSTANTS.archiveActions.state:
                this.activateArchive();
                break;

            default:
                return;
        }
    }

	editRetention() {
		this.editRetentionPeriod = {
			period: this.config.retention.period,
			value: this.config.retention.value,
		};

	}

	editRetentionExecute() {
		this.editRetentionPeriod.inProcess = true;
		const actionData = {
			type: this.dic.CONSTANTS.archiveActions.retention,
			period: this.editRetentionPeriod.period,
			value: this.editRetentionPeriod.value,
		};

		this.rs.updateArchiveConfigurations(actionData).then((response) => {
			this.config.retention.period = this.editRetentionPeriod.period;
			this.config.retention.value = this.editRetentionPeriod.value;
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
			this.editRetentionPeriod = null;
		}, (err) => {
		});
	}

    activateArchive = () => {
        const actionData = {
            type: this.dic.CONSTANTS.archiveActions.state,
            enabled: this.config.enabled
        };
         if (!actionData.enabled) {
             this.gs.showPopup({
                 title: 'Disable Archive',
                 subTitle: `Are you sure you want to disable archive?`,
                 body: ['Outbound and inbound emails will no longer be saved in the archive and you will not be able to access previously archived emails'],
                 type: this.dic.CONSTANTS.popupWarning,
                 doneBtnText: 'Disable',
                 doneCb: () => {
                     this.executeArchive(actionData);
                 },
                 cancelCb: () => {
                     this.config.enabled = !this.config.enabled;
                 }
             });
         }
         else {
             this.executeArchive(actionData);
         }
    }

    executeArchive(actionData) {
        this.rs.updateArchiveConfigurations(actionData).then((response) => {
            this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
        }, (err) => {
            this.config.enabled = !this.config.enabled;
        });
    }

}
